module.exports = __webpack_public_path__ + "img/rowB1.c340f338.png";